{
  "familyId": "SPR-KLANK-VERKORTEN",
  "questions": [
    {
      "id": "SPR-KLANK-VERKORTEN-001",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'maan'?",
      "options": ["manen", "maanen", "mannen", "maan"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "ma-nen",
            "syllables": ["ma", "nen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: ma-nen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep (eindigt op een klinker) schrijf je maar één klinker voor de lange klank. Ma-nen: 'ma' is open → één 'a' volstaat.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_aa",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het meervoud van 'maan' is 'manen'. In een open lettergreep (ma-nen) schrijf je maar één klinker voor de lange klank. De 'aa' wordt 'a' omdat de lettergreep 'ma' open is — hij eindigt op een klinker. Onthoud: open lettergreep = lange klank met één klinker.",
        "solutionSteps": [
          "Maan heeft een lange 'aa'-klank",
          "Meervoud: maan + en = manen",
          "Verdeel in lettergrepen: ma-nen",
          "'Ma' eindigt op een klinker → open lettergreep",
          "Open lettergreep → één klinker volstaat: manen"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Manen' — in de open lettergreep 'ma-' schrijf je maar één 'a'.",
          "1": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'maanen'. Maar in een open lettergreep (ma-nen) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker voor de lange klank.",
          "2": "Je dacht waarschijnlijk dat het 'mannen' is. Maar 'mannen' is het meervoud van 'man' (korte 'a'-klank). 'Maan' heeft een lange klank, dus het meervoud is 'manen'. Onthoud: maan → manen (lang), man → mannen (kort).",
          "3": "Je dacht waarschijnlijk dat 'maan' al het meervoud is. Maar 'maan' is enkelvoud (één maan). Het meervoud is 'manen' (meerdere manen). Onthoud: voeg '-en' toe voor het meervoud."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-002",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Welk woord is GOED gespeld?",
      "options": ["boomen", "bommen", "boom", "bomen"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "bo-men",
            "syllables": ["bo", "men"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: bo-men"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Bo-men: 'bo' is open → één 'o' voor de lange klank.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_oo",
      "variantIndex": 2,
      "citoDifficulty": 0.23,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Bomen' is correct. Boom → bomen. In de open lettergreep 'bo-' schrijf je maar één 'o'. De lange klank blijft behouden door de open lettergreep. Onthoud: open lettergreep = één klinker voor de lange klank.",
        "solutionSteps": [
          "Boom heeft een lange 'oo'-klank",
          "Meervoud: boom + en = bomen",
          "Verdeel: bo-men ('bo' is open lettergreep)",
          "Open lettergreep → één klinker: bomen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'boomen'. Maar in een open lettergreep (bo-men) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker.",
          "1": "Je dacht waarschijnlijk dat het 'bommen' is. Maar 'bommen' is het meervoud van 'bom' (korte 'o'-klank, als in een explosie). 'Boom' heeft een lange klank, dus het meervoud is 'bomen'. Onthoud: boom → bomen (lang), bom → bommen (kort).",
          "2": "Je dacht waarschijnlijk dat 'boom' al goed is. Maar de vraag vraagt welk woord goed gespeld is als meervoud. 'Boom' is enkelvoud. Het meervoud is 'bomen'.",
          "3": "Goed! 'Bomen' — open lettergreep 'bo-' houdt de lange klank met één 'o'."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-003",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Waarom schrijf je 'lopen' met één 'o' en niet 'loopen'?",
      "options": [
        "Omdat de 'o' kort is",
        "Omdat er een medeklinker achter staat",
        "Omdat 'lo' een open lettergreep is — de lange klank blijft vanzelf",
        "Omdat het een werkwoord is"
      ],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "lo-pen",
            "syllables": ["lo", "pen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: lo-pen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waarom één klinker?",
            "content": "In een open lettergreep (eindigt op een klinker) is de klank automatisch lang. Daarom schrijf je maar één klinker: lo-pen, niet loo-pen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_reason",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "In 'lo-pen' is 'lo' een open lettergreep (eindigt op een klinker). In een open lettergreep is de klank automatisch lang, dus je hoeft maar één klinker te schrijven. Daarom schrijf je 'lopen' en niet 'loopen'. Onthoud: open lettergreep = lange klank met één klinker.",
        "solutionSteps": [
          "Verdeel in lettergrepen: lo-pen",
          "'Lo' eindigt op een klinker → open lettergreep",
          "Open lettergreep = klank is automatisch lang",
          "Dus: één klinker volstaat → 'lopen', niet 'loopen'"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat de 'o' kort is. Maar de 'o' in 'lopen' is lang (zoals in 'loop'). In een open lettergreep is de klank automatisch lang, ook met maar één klinker. Onthoud: open lettergreep = lange klank.",
          "1": "Je dacht waarschijnlijk dat de medeklinker erachter de reden is. Maar het gaat om het type lettergreep: open (eindigt op klinker) of gesloten (eindigt op medeklinker). 'Lo-' is open → lange klank met één klinker.",
          "2": "Goed! De open lettergreep 'lo-' houdt de lange klank met maar één 'o'.",
          "3": "Je dacht waarschijnlijk dat de regel alleen voor werkwoorden geldt. Maar de regel geldt voor alle woorden: bomen, manen, lopen, ramen — allemaal open lettergrepen met één klinker. Onthoud: het gaat om de lettergreep, niet om de woordsoort."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-004",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'been'?",
      "options": ["beenen", "benen", "bennen", "been"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "be-nen",
            "syllables": ["be", "nen"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: be-nen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Be-nen: 'be' is open → één 'e' voor de lange klank.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_ee",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Benen' is correct. Been → benen. In de open lettergreep 'be-' schrijf je maar één 'e'. De lange klank blijft behouden door de open lettergreep. Onthoud: open lettergreep = één klinker voor de lange klank.",
        "solutionSteps": [
          "Been heeft een lange 'ee'-klank",
          "Meervoud: been + en = benen",
          "Verdeel: be-nen ('be' is open lettergreep)",
          "Open lettergreep → één klinker: benen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de dubbele klinker moet behouden: 'beenen'. Maar in een open lettergreep (be-nen) is de klank automatisch lang met één klinker. Onthoud: open lettergreep = één klinker.",
          "1": "Goed! 'Benen' — open lettergreep 'be-' houdt de lange klank met één 'e'.",
          "2": "Je dacht waarschijnlijk dat het 'bennen' is. Maar 'bennen' zou een korte 'e'-klank geven (als in 'ben'). 'Been' heeft een lange klank, dus het meervoud is 'benen'. Onthoud: been → benen (lang), ben → bennen (kort).",
          "3": "Je dacht waarschijnlijk dat 'been' al het meervoud is. Maar 'been' is enkelvoud (één been). Het meervoud is 'benen' (twee benen). Onthoud: voeg '-en' toe voor het meervoud."
        }
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-005",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'raam'. Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["ramen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "ra-men",
            "syllables": ["ra", "men"],
            "types": ["open", "closed"],
            "highlight": [0],
            "label": "Open lettergreep: ra-men"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Open lettergreep",
            "content": "In een open lettergreep schrijf je maar één klinker. Ra-men: 'ra' is open → één 'a' voor de lange klank. Dus: ramen, niet raamen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "open_syllable_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Raam → ramen. In de open lettergreep 'ra-' schrijf je maar één 'a'. De lange klank blijft behouden door de open lettergreep. Onthoud: raam heeft een lange 'aa', maar in het meervoud schrijf je maar één 'a' (ra-men).",
        "solutionSteps": [
          "Raam heeft een lange 'aa'-klank",
          "Meervoud: raam + en = ramen",
          "Verdeel: ra-men ('ra' is open lettergreep)",
          "Open lettergreep → één klinker: ramen"
        ]
      }
    },
    {
      "id": "SPR-KLANK-VERKORTEN-006",
      "familyId": "SPR-KLANK-VERKORTEN",
      "module": "SpellingRegel",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_klinker_verkorten",
      "questionType": "categorize",
      "question": "Sorteer deze meervoudsvormen: welke zijn GOED en welke zijn FOUT gespeld?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Goed gespeld", "Fout gespeld"],
        "items": [
          { "text": "manen", "correctCategory": 0 },
          { "text": "boomen", "correctCategory": 1 },
          { "text": "benen", "correctCategory": 0 },
          { "text": "raamen", "correctCategory": 1 },
          { "text": "lopen", "correctCategory": 0 },
          { "text": "deeken", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Open lettergreep = één klinker", "content": "In een open lettergreep schrijf je de lange klank met één letter:\nma-nen ✓ (niet maa-nen), bo-men ✓ (niet boo-men)\nbe-nen ✓ (niet bee-nen), ra-men ✓ (niet raa-men)\nlo-pen ✓ (niet loo-pen), de-ken ✓ (niet dee-ken)", "icon": "lightbulb" } }
      ],
      "conceptId": "open_syllable_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In een open lettergreep schrijf je de lange klank met één letter. Goed: manen, benen, lopen. Fout: boomen (moet bomen zijn), raamen (moet ramen zijn), deeken (moet deken zijn).",
        "solutionSteps": [
          "Verdeel in lettergrepen: open lettergreep → één klinker",
          "Goed: ma-nen, be-nen, lo-pen (één klinker ✓)",
          "Fout: boo-men, raa-men, dee-ken (dubbele klinker ✗)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}